export default __webpack_public_path__ + "static/media/checkbox_checkmark.cc320fcc.svg";